/**
 * Response status is used to identify the state of loading products
 */
// ****************************************
//     State diagram for ResponseStatus
// ****************************************
//                          FAILED
//                        /         \
//   INIT  -> LOADING   <->  EMPTY  <->
//                        \         /
//                          SUCCEED
// ****************************************
export var ResponseStatus;
(function (ResponseStatus) {
    /**
     * The state is initiated but still no request triggered (this is the start state, there is no turn back after switching to other states)
     */
    ResponseStatus["INIT"] = "INIT";
    /**
     * Request is triggered and waiting for response
     */
    ResponseStatus["LOADING"] = "LOADING";
    /**
     * Request is triggered and waiting for response to be appended
     */
    ResponseStatus["LAZY_LOADING"] = "LAZY_LOADING";
    /**
     * Processing of request failed
     */
    ResponseStatus["FAILED"] = "FAILED";
    /**
     * The request was successfully processed but the response contains no products (empty result or result list)
     */
    ResponseStatus["EMPTY"] = "EMPTY";
    /**
     * The request was successfully processed and the response contains products
     */
    ResponseStatus["SUCCEED"] = "SUCCEED";
})(ResponseStatus || (ResponseStatus = {}));
export default ResponseStatus;
